import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: ()=>import("../views/HomeIndex.vue")
  },
  {
    path: '/index',
    name: 'index',
    component: ()=>import("../views/IndexData.vue")
  },

]

const router = new VueRouter({
  routes
})

export default router
